import PopoverBox from "../../../components/popover-box";
import React from "react";
import styled from "styled-components";
import { Translation } from "../../../core/translate";
import { connect } from "react-redux";
import {
  actions as storageActions,
  selectors as storageSelectors
} from "../../../../redux/storage";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import Books from "./books";

const Styled = {
  Container: styled.div`
    display: flex;
    gap: 15px;
  `,
  ArtContainer: styled.div`
    flex: 0;
    padding-top: 11px;
  `,
  TextContainer: styled.div`
    flex: 1;
  `,
  Header: styled.div`
    font-weight: 500;
    padding-bottom: 4px;
  `
};

function SubscriptionPopover(props) {
  return (
    <PopoverBox
      isOpen={props.shouldShow}
      onClose={props.setViewed}
      maxWidth={361}
      className={props.className}
      arrowOffset={props.arrowOffset}
      targetOffset={props.targetOffset}
      boxOffset={props.boxOffset}
    >
      <Styled.Container>
        <Styled.ArtContainer>
          <Books />
        </Styled.ArtContainer>
        <Styled.TextContainer>
          <Styled.Header>
            <Translation id="explore.sub-added">Subscription added</Translation>
          </Styled.Header>
          <p>
            <Translation id="explore.new-subs-appear">
              New subscriptions will show up in your Explore tab. When you open
              a book, it will appear in My Library.
            </Translation>
          </p>
        </Styled.TextContainer>
      </Styled.Container>
    </PopoverBox>
  );
}

const STORAGE_KEY = "subscription-popover-status";

function hasPromoBeenViewed(state) {
  const currentStoredValue = storageSelectors.getKey(state, STORAGE_KEY);
  if (currentStoredValue) {
    return !!currentStoredValue.viewedAt;
  }
  return false;
}

export default connect(
  state => ({
    shouldShow: bridgeSelectors.hasPromoSub(state) && !hasPromoBeenViewed(state)
  }),
  dispatch => ({
    setViewed: () => {
      dispatch(
        storageActions.setKey(STORAGE_KEY, {
          viewedAt: new Date().toISOString()
        })
      );
    }
  })
)(SubscriptionPopover);
